import { toggleSettingsTeachingBubble } from '@ms/yammer-data/dist/domains/roleBasedFREs/actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useCloseSettingsTeachingBubbleCallback = () => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(toggleSettingsTeachingBubble(false));
  }, [dispatch]);
};
